import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';

import { getReducer as getAbtestingReducer } from '@pegasus/abtesting';
import myloungeLegacy from './modules/mylounge-legacy/reducer';
import mylounge from './modules/mylounge/reducer';
import backToTop from './modules/backToTop/reducer';
import exchangeRates from './modules/exchangeRates/reducer';
import clientDevice from '@client/redux/modules/clientDevice/reducer';
import customer from './modules/customer/reducer';
import footer from './modules/footer/reducer';
import user from './modules/user/reducer';
import routing from './modules/routing/reducer';
import serverContext from './modules/serverContext/reducer';
import flashMessage from './modules/flashMessage/reducer';
import salesforceChat from './modules/salesforceChat/reducer';
import tracking from './modules/tracking/reducer';
import preliminarySession from './modules/preliminarySession/reducer';
import successOverlay from './modules/successOverlay/reducer';
import countrySelection from './modules/countrySelection/reducer';
import pushNotification from './modules/pushNotification/reducer';
import myloungeMetadata from './modules/myloungeMetadata/reducer';
import headerCampaigns from './modules/headerCampaigns/reducer';
import cart, { NAMESPACE as CART_NS } from '@client/lib/cart/redux/reducer';

export default combineReducers({
    ...getAbtestingReducer(),
    backToTop,
    [CART_NS]: cart,
    clientDevice,
    customer,
    exchangeRates,
    flashMessage,
    footer,
    myloungeLegacy,
    mylounge,
    router,
    routing,
    serverContext,
    tracking,
    user,
    salesforceChat,
    preliminarySession,
    successOverlay,
    countrySelection,
    pushNotification,
    myloungeMetadata,
    headerCampaigns,
});
